<template>
  <div v-if="filename" id="LaVr" :class="{ blur }">
    <bg-video ref="bv" filename="Experience-1" autoplay loop/>
    <img class="logo" :src="require(`../assets/img/LaVr/logo-${filename}.png`)" alt="logo">
    <div class="btn-wrap">
      <a class="btn" title="实景" :style="{backgroundImage: `url(${require(`../assets/img/LaVr/la-${filename}.png`)})`}" @click="play('LA')"/>
      <a class="btn" title="虚拟" :style="{backgroundImage: `url(${require(`../assets/img/LaVr/vr-${filename}.png`)})`}" @click="play('VR')"/>
    </div>
    <guide-button class="btn-rt" @click="$emit('close')">继续</guide-button>
  </div>
</template>

<script>
export default {
  name: 'LaVr',
  props: {
    filename: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      blur: false,
    }
  },
  methods: {
    play (type) {
      this.blur = true
      this.$vplayer.play({ url: `${type}/${this.filename}` }).then(_ => {
        this.blur = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#LaVr {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 101;
  width: 19.2rem;
  height: 10.8rem;
  text-align: center;
  background-size: cover;
  background-image: url(../views/Experience/img/bg.jpg);
  .logo {
    position: relative;
    top: 1rem;
  }
  .btn-wrap {
    position: absolute;
    top: 3.2rem;
    width: 100%;
    height: 5.75rem;
    text-align: center;
    .btn {
      display: inline-block;
      width: 6.5rem;
      height: 5.75rem;
      margin: 0 0.2rem;
      cursor: pointer;
      &:first-child {
        // background-image: url(../views/Experience/img/btn1.png);
        background-size: cover;
      }
      &:last-child {
        background-image: url(../views/Experience/img/btn2.png);
        background-size: cover;
      }
    }
  }
}
</style>
